import { queryKeysBuilder } from '@/api/queries.utils';
import { beneficiariesQueryKeys } from '../beneficiaries/beneficiaries.query-keys';

const builder = queryKeysBuilder([...beneficiariesQueryKeys.all, 'employees-beneficiaries']);

export const employeesBeneficiariesQueryKeys = {
  all: builder(),
  one: (id: number) => builder('one', id),
};
